<template>
  <el-card class="box-card">
    <div slot="header" class="flex justify-between">
      <span>员工信息</span>
      <div>
        <el-button 
          type="primary" 
          size="small" 
          @click="openSearchStaffModel"
          icon="el-icon-search"
        >定位员工</el-button>
        <el-button 
          type="primary" 
          size="small" 
          v-if="privilegeStaffInfo.userId"
          @click="openAddStaffPrivilegeModel"
          icon="el-icon-plus"
          style="margin-left: 10px;"
        >添加权限</el-button>
      </div>
    </div>
    <el-row :gutter="20">
      <el-col :span="6">
        <el-form-item label="员工ID：">
          <el-input v-model="privilegeStaffInfo.userId" readonly></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="员工名称：">
          <el-input v-model="privilegeStaffInfo.name" readonly></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="手机号：">
          <el-input v-model="privilegeStaffInfo.tel" readonly></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item label="邮箱：">
          <el-input v-model="privilegeStaffInfo.email" readonly></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="6">
        <el-form-item label="性别：">
          <el-input 
            :value="privilegeStaffInfo.sex === 0 ? '男' : (privilegeStaffInfo.sex === 1 ? '女' : '')" 
            readonly
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="18">
        <el-form-item label="地址：">
          <el-input v-model="privilegeStaffInfo.address" readonly></el-input>
        </el-form-item>
      </el-col>
    </el-row>
  </el-card>
</template>

<script>
export default {
  name: 'PrivilegeStaffInfo',
  data() {
    return {
      privilegeStaffInfo: {
        userId: "",
        name: "",
        tel: "",
        email: "",
        sex: "",
        address: "",
      }
    }
  },
  methods: {
    openSearchStaffModel() {
      this.$emit('openSearchStaff')
    },
    openAddStaffPrivilegeModel() {
      this.$emit('openAddStaffPrivilege', {
        userId: this.privilegeStaffInfo.userId
      })
    },
    chooseStaff(staff) {
      this.privilegeStaffInfo = staff
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}
</style>